import axios from "axios";
import APIRoutes from "../../APIRoutes";
import SonicOffer from "../../../common/classes/SonicOffer";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import SonicOfferMeta, {
  SonicOfferMetaData,
} from "../../../common/classes/SonicOfferMeta";

/**
 * getOffersAdmin
 *
 * Fetches offer data for admin page.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param isSelect Whether the request is from SELeCT or not.
 * @param id ID you wish to fetch
 * @param page Current page for pagination
 * @param per_page Results per page
 * @param search Search keyword
 * @param sort_by Which parameter us use to filter
 * @param desc Whether or not results are ascending or descending
 * @returns An array of offers.
 */

export const getOffersAdmin = async (
  args: {
    auth_token: string;
    isSelect: boolean;
    id?: string;
    page?: number;
    per_page?: number;
    search?: string;
    sort_by?: string;
    desc?: boolean;
  },
  signal?: AbortSignal
) => {
  try {
    const res = await axios.get(
      getAPIRoot(APIRoutes.get.offer, args.isSelect ? "admin" : "jikei"),
      {
        headers: {
          "X-Sonic-Auth": args.auth_token,
        },
        params: {
          offer_id: args.id,
          pg: args.page,
          per: args.per_page,
          sort: args.sort_by,
          desc: args.desc,
          s: args.search,
        },
        signal,
      }
    );

    const offers: Array<SonicOffer> = [];
    const metadatas: Array<SonicOfferMetaData> = [];

    res.data.message.items.forEach((o: any) => {
      const offer = SonicOffer.parseFromAPIResponse(o.offer);
      const meta = SonicOfferMeta.parseFromAPIResponse(o.meta);

      offers.push(offer);
      metadatas.push(meta);
    });

    return {
      total_pages: res.data.message.total_pages,
      page: res.data.message.page,
      total_entries: res.data.message.total_entries,
      offers: offers,
      meta: metadatas,
    };
  } catch (e) {
    return null;
  }
};
